import { render, staticRenderFns } from "./ReceivedEmailsPagination.vue?vue&type=template&id=cbeab246&"
import script from "./ReceivedEmailsPagination.vue?vue&type=script&lang=js&"
export * from "./ReceivedEmailsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbeab246')) {
      api.createRecord('cbeab246', component.options)
    } else {
      api.reload('cbeab246', component.options)
    }
    module.hot.accept("./ReceivedEmailsPagination.vue?vue&type=template&id=cbeab246&", function () {
      api.rerender('cbeab246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/receivedEmails/ReceivedEmailsPagination.vue"
export default component.exports